<template>
	<div>
		<!-- add/edit dialog -->
		<v-dialog v-model="dialog" max-width="650" :persistent="submitLoading">
			<v-form
				ref="orderForm"
				:disabled="submitLoading || isPreview"
				@submit.prevent="submit"
			>
				<v-card>
					<v-card-title class="justify-center text-capitalize primary--text py-2">
						<v-btn @click="dialog = false" icon>
							<v-icon>$close</v-icon>
						</v-btn>
						<v-spacer/>
						<span class="me-8">
							{{!isPreview ? (!orderItem ? $T('add') : $T('edit')) : $T('preview')}} 
							{{
								currentProductionType === productionType.order
									? $T('production-order')
									: $T('order-result')
							}}
						</span>
						<v-spacer/>
					</v-card-title>
					<v-card-text class="pb-0">
						<v-row dense>
							<!-- date -->
							<v-col md="4" sm="6" cols="12">
								<bee-date-picker
									v-model="dialogData.date"
									:label="$T('inputs.date')"
									dense
									outlined
									hide-details
									menu-picker
									:input-props="{ readonly: true, dense: true, outlined: true }"
									:rules="rules.required"
								></bee-date-picker>
							</v-col>

							<!-- lot -->
							<v-col md="4" sm="6" cols="12">
								<v-text-field
									v-model="lot"
									dense
									outlined
									hide-details
									:readonly="isPreview"
									:label="$T('inputs.lot')"
								></v-text-field>
							</v-col>

							<!-- is-reproduction -->
							<v-col
								v-if="currentProductionType === productionType.order"
								md="4"
								sm="6"
								cols="12"
							>
								<v-checkbox
									v-model="isReproduction"
									:label="$T('inputs.is-reproduction')"
									dense
									outlined
									hide-details
									class="mt-0 pt-0"
									:readonly="isPreview"
									@change="$event ? dialogData.entires[0].itemId = rawCardamomId : null"
								></v-checkbox>
							</v-col>

							<v-col cols="12">
								<bee-handy-smart-table
									ref="entiresTable"
									:headers="dialogHeaders"
									:items="dialogData.entires.filter(c => isPreview ? c.quantity : true)"
									:items-per-page="-1"
									fixed-header
									:height="dialogData.entires.length > 10 && !isPreview ? $vuetify.breakpoint.height - 280 : null"
									zebra
									dense
									hot-inputs
									hide-default-footer
									hide-inputs-details
									:data-table-props="{
										disableSort: true,
										noDataText: $T('messages.select-Item-to-purchase')
									}"
								>
									<!-- item name -->
									<template v-if="!isPreview" v-slot:item.itemName="{ item }">
										<v-autocomplete
											v-if="
												isReproduction || 
												currentProductionType !== productionType.order
											"
											v-model="item.itemId"
											item-text="name"
											item-value="id"
											:items="flatCardamomItems.filter(c =>
												!dialogData.entires.map(e => e.itemId).includes(c.id) ||
												c.id === item.itemId
											)"
											dense
											hide-details
											:clearable="currentProductionType !== productionType.order"
											class="mb-4"
											:append-icon="currentProductionType === productionType.order ? '' : undefined"
											:readonly="!isReproduction && currentProductionType === productionType.order"
											@change="() => {
												if (currentProductionType === productionType.order) return;
												if (item.itemId) {
													dialogData.entires.push({
														id: dialogData.entires.length + 1,
														itemId: null,
														itemName: null,
														quantity: null,
														ownerId: null,
														notes: null,
														quantity: 0
													})
												} else {
													dialogData.entires.pop();
												}
											}"
										/>
										<!-- lot: null, -->
										<span v-else>{{item.itemName}}</span>
									</template>

									<!-- owner -->
									<template v-if="!isPreview" v-slot:item.ownerId="{ item }">
										<v-autocomplete
											v-model="item.ownerId"
											dense
											hide-details
											item-text="name"
											item-value="id"
											class="mb-2"
											:items="[
												{ id: null, name: 'Ugarit' },
												...owners
											]"
										/>
									</template>

									<!-- actions -->
									<template v-slot:item.actions="{ item, index }">
										<v-btn
											v-if="item.isNotDefault"
											icon
											@click="dialogData.entires.splice(index, 1)"
											color="alert-color"
										>
											<v-icon>$delete</v-icon>
										</v-btn>
									</template>
								</bee-handy-smart-table>

								<div class="d-flex justify-center text-body-1 font-weight-bold primary--text pt-2">
									<v-spacer/>
									<div class="px-2" style="">
										{{ $T('total') }}:
										<span
											class="ps-1"
										>
											{{ 
												dialogData.entires.length > 0
													? $options.filters.numberFormat(fixNumber(dialogData.entires.filter(c => isPreview ? c.quantity : true).map(c => c.quantity)?.reduce((a, b) => a + b)))
													: 0 
											}}
										</span>
									</div>
									<v-spacer/>
									<v-spacer/>
									<v-spacer/>
								</div>
								
							</v-col>
						</v-row>
					</v-card-text>
					<v-card-actions>
						<v-btn
							outlined
							:ripple="false"
							color="primary"
							class="me-1 mx-2"
							small
							@click="generatePrint(false)"
						>
							<v-icon>$print</v-icon>
						</v-btn>

						<v-spacer />

						<v-btn
							v-if="!isPreview"
							type="submit"
							color="primary"
							:loading="submitLoading"
						>{{$T('save')}}</v-btn>
						<v-btn @click="dialog = false" :disabled="submitLoading">{{$T('close')}}</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>

		<!-- delete dialog -->
		<v-delete-dialog
			v-model="deleteDialog"
			module-type="productionJournals"
			:ids="orderItem?.id"
			@on-delete="filter();"
			@input="!$event ? orderItem = null : null"
		>
			{{$T('are-you-sure-you-want-to-$', { message: '' })}}
			<span class="text-uppercase alert-color--text">{{$T('delete')}}</span>
			{{$T('the-entry')}} <br>
		</v-delete-dialog>

		<!-- filter -->
		<v-form @submit.prevent="filter()">
			<v-row dense align="center" class="mb-0">
				<!-- owner -->
				<v-col lg="2" md="3" sm="4" cols="12">
					<v-autocomplete
						v-model="filterData.ownerIds"
						:items="[
							{id: '00000000-0000-0000-0000-000000000000', name: 'Ugarit', type: 1 },
							...owners
						]"
						item-text="name"
						item-value="id"
						:label="$T('inputs.owner')"
						outlined
						dense
						hide-details
						multiple
						clearable
					>
						<template v-slot:selection="{ index, item }">
							<span v-if="index === 0" class="mx-1">{{ item.name }}</span>
							<span v-if="index === 1">   +({{ filterData.ownerIds.length - 1 }}) </span>
						</template>
					</v-autocomplete>
				</v-col>

				<v-col lg="2" md="3" sm="4" cols="6">
					<bee-date-picker
						v-model="filterData.fromDate"
						:input-label="$T('inputs.start-date')"
						:input-props="{
							dense: true,
							outlined: true,
							readonly: true,
							clearable: true,
							prependInnerIcon: '$calendar',
						}"
						menu-picker
						hide-details
					/>
				</v-col>
				
				<v-col lg="2" md="3" sm="4" cols="6">
					<bee-date-picker
						v-model="filterData.toDate"
						:input-label="$T('inputs.end-date')"
						:input-props="{
							dense: true,
							outlined: true,
							readonly: true,
							clearable: true,
							prependInnerIcon: '$calendar',
						}"
						menu-picker
						hide-details
					/>
				</v-col>

				<v-col cols="auto">
					<v-btn small type="submit" color="primary">
						<v-icon>$search</v-icon>
					</v-btn>
				</v-col>

				<!-- <v-spacer/> -->
				<v-btn
					v-if="currentProductionType === productionType.order ? permissions.managingProductionOrders.isReadWrite : currentProductionType !== productionType.order ? permissions.managingOrderResults.isReadWrite : false"
					small
					color="primary"
					@click="dialog = true"
					class="text-none"
				>
					<v-icon class="me-1">$add</v-icon>
					{{$T('add')}}
					{{
						currentProductionType === productionType.order
							? $T('production-order')
							: $T('order-result')
					}}
				</v-btn>
				<v-spacer />
				<v-divider vertical class="mx-2 my-2" />
				<v-col>
					<v-menu
						v-model="showMenu"
						absolute
						offset-y
						style="max-width: auto"
						dense	
					>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								v-bind="attrs"
								v-on="on"
								dense
								height="30"
								class="px-1 black--text text-none"
							>
								<div class="px-2 py-0 d-flex align-center">
									{{ $t('cardamom-in-the-detachment') }}
									<span class="text-h5 primary--text font-weight-bold mx-2">
										{{ 
											cardamomAmountInSorting.length 
												? $options.filters.numberFormat(fixNumber(cardamomAmountInSorting
													.map(c => c.remainingQty > 0 ? c.remainingQty : 0)
													.reduce((a, b) => a+ b)))
												: '-' 
										}}
									</span> 
									<v-icon> mdi-chevron-down </v-icon>
								</div>
							</v-btn>
						</template>

						<bee-handy-table
							:headers="headersCardamom"
							:items="cardamomAmountInSorting"
							zebra
							dense
							:items-per-page="-1"
							:data-table-props="{ disableSort: true }"
							hide-default-footer
						></bee-handy-table>
					</v-menu>
				</v-col>
				<v-btn
					outlined
					:ripple="false"
					color="primary"
					class="me-1 mx-2"
					@click="printAll()"
					small
				>
					<v-icon>$print</v-icon>
				</v-btn>
			</v-row>
		</v-form>

		<bee-handy-table
			ref="table"
			:headers="headers"
			:items="[]"
			:items-per-page="20"
			fixed-header
			:height="$vuetify.breakpoint.height - 165"
			zebra
			dense
			pagination-on-scroll
			pagination-on-scroll-server-items
			:server-items-length="totalItems"
			:options-scroll.sync="scrollOptions"
			shown-rows-text
			:loading="loading"
			:data-table-props="{ disableSort: true }"
			@pagination-on-scroll:reach-last-row="filter"
		>
			<template v-slot:item.weight="{ item }">
				{{$options.filters.numberFormat(fixNumber(item.workItems.reduce((res, a) => res + a.quantity, 0)))}}
			</template>		
			<template v-slot:item.actions="{ item }">
				<div class="d-flex">
					<v-btn
						v-if="currentProductionType !== productionType.order"
						width="34"
						height="34"
						icon
						color="preview-color"
						@click="isPreview = true; orderItem = item; dialog = true;"
					>
						<v-icon>$view</v-icon>
					</v-btn>
					
					<v-btn
						v-if="currentProductionType === productionType.order ? permissions.managingProductionOrders.isReadWrite : currentProductionType !== productionType.order ? permissions.managingOrderResults.isReadWrite : false"
						width="34"
						height="34"
						icon
						color="warning-color"
						@click="orderItem = item; dialog = true;"
					>
						<v-icon>$edit</v-icon>
					</v-btn>

					<v-btn
						v-if="currentProductionType === productionType.order ? permissions.managingProductionOrders.isReadWrite : currentProductionType !== productionType.order ? permissions.managingOrderResults.isReadWrite : false"
						width="34"
						height="34"
						icon
						color="error"
						@click="orderItem = item; deleteDialog = true;"
					>
						<v-icon>$delete</v-icon>
					</v-btn>
				</div>
			</template>
		</bee-handy-table>
		<!-- footer for total statistics -->
		<v-footer app inset elevation="10" class="justify-space-around grey lighten-2">
			<div>
				{{$T('total')}}:
				<span class="ms-2 font-weight-bold">
					{{
						(total ? ($options.filters.numberFormat(fixNumber(+total))) : 0) + ' qq'
					}}
				</span>
			</div>
		</v-footer>
	</div>
</template>

<script>
import { productionType, type, cardamomStatus } from '@/helpers/enums'
import { mapGetters, mapState } from 'vuex';
import rules from '@/helpers/validation-rules';
import { getFlatTree, fixNumber } from '@/helpers/functions';
import moment from 'moment'
import { generateHtmlPdf } from '@/helpers/generate-html';
import printJS from 'print-js';

export default {
	name: 'ProductionJournals',

	data() {
		return {
			productionType,
			rules,

			loading: false,
			submitLoading: false,

			deleteDialog: null,

			// dialog
			dialog: false,
			orderItem: null,
			isPreview: false,

			// filter
			filterData: {
				fromDate: null,
				toDate: null,
				ownerIds: []
			},

			// pagination
			totalItems: null,
			scrollOptions: {},

			// submit
			dialogData: {
				date: new Date().toISOString().slice(0, 10),
				entires: []
			},
			showMenu: false,
			cardamomStatus,
			total: 0,
			lot: 0,
			isReproduction: false,
			productionJournals: []
		}
	},

	watch: {
		'$route.name'() {
			this.filter();
		},
		
		dialog(val) {
			if (val) {
				const setEntries = (data = [], isRawCardamom) => {
					this.dialogData.entires = [];
					this.subTreeItemId = this.cardamomRootId || this.items[0]?.id;
					if (!this.subTreeItemId) return;
					// const subTree = this.itemsTree.find(c => c.id === this.subTreeItemId);

					if (isRawCardamom) {
						this.isReproduction = data.some(c => c.itemId !== this.rawCardamomId);
						const item = data.find(c =>
							c.itemId === (!this.isReproduction ? this.rawCardamomId : c.itemId)
						);
						
						this.dialogData.entires.push({
							id: 1,
							itemId: !this.isReproduction ? this.rawCardamomId : item.itemId,
							itemName: this.getItemById(this.rawCardamomId)?.name,
							quantity: item ? item.quantity : 0,
							ownerId: item ? item.ownerId : null,
							lot: item ? item.lot : null,
							notes: item ? item.notes : null,
						});
					} else {
						data.forEach(c => {
							this.dialogData.entires.push({
								id: this.dialogData.entires.length,
								itemId: c.itemId,
								itemName: null,
								quantity: c.quantity,
								ownerId: c.ownerId,
								lot: c.lot,
								notes: c.notes,
							});
						})
					}
					if (!this.isPreview && !isRawCardamom) {
						this.dialogData.entires.push({
							id: this.dialogData.entires.length,
							itemId: null,
							itemName: null,
							ownerId: null,
							lot: null,
							notes: null,
							quantity: 0
						})
					}
					if (this.orderItem) {
						this.dialogData.date = moment(this.orderItem.date).format('YYYY-MM-DD')
						this.lot = this.dialogData.entires.length ? this.dialogData.entires[0].lot : 0
					}
				}
				
				if (this.orderItem) {
					setEntries(this.orderItem.workItems, this.currentProductionType === productionType.order)
				} else {
					setEntries([], this.currentProductionType === productionType.order);
				}
			} else {
				this.orderItem = null;
				this.isPreview = false;
				this.dialogData.date = new Date().toISOString().slice(0, 10);
				this.lot = null;
				this.isReproduction = false;
				this.dialogData.entires = [];
			}
		}
	},

	computed: {
		...mapState({
			permissions: state => state.auth.self.permissions,
			cardamomRootId: state => state.configs.itemsConfigs.cardamomRootId,
			rawCardamomId: state => state.configs.itemsConfigs.rawCardamomId,
			items: state => state.items.items,
			itemsTree: state => state.items.itemsTree,
			owners: state => state.configs.configsTrees.owners,
			cardamomAmountInSorting: state => state.transactions.cardammanAmount
		}),
		...mapGetters({
			getItemById: 'items/getItemById'
		}),

		flatCardamomItems() {
			let items = [];
			if (this.cardamomRootId) {
				items = getFlatTree([this.itemsTree.find(c => c.id === this.cardamomRootId)]);
				items.push(this.getItemById(this.rawCardamomId))
			} else {
				items = this.items.filter(c => c.type === type.sub);
			}
			return items;
		},

		currentProductionType() {
			switch (this.$route.name) {
			case 'production-orders': return productionType.order;
			case 'order-results': return productionType.results;
			default: return null;
			}
		},

		itemsHeaders() {
			const subTreeItemId = this.cardamomRootId || this.itemsTree[0].id;
			if (!subTreeItemId) return;
			const subTree = this.itemsTree.find(c => c.id === subTreeItemId);

			const headers = [];

			const getHeaderColor = (priority) => {
				switch (priority) {
				case 1: return 'primary-priority-1';
				case 2: return 'secondary-priority-1';
				case 3: return 'thirdly-priority-1';
				default: return '';
				}
			}
			const getCellColor = (priority) => {
				switch (priority) {
				case 1: return 'primary-priority-2';
				case 2: return 'secondary-priority-2';
				}
				if (priority < 10) {
					return `thirdly-priority-${priority - 1}`
				}
				return ''
			}

			subTree.children.forEach((c, i) => {
				if (c.children.length) {
					c.children.forEach(e => {
						headers.push({
							text: e.name + ' (qq)',
							name: e.name,
							value: e.id,
							align: 'center',
							type: 'number-format',
							class: getHeaderColor(i < 2 ? i + 1 : 3),
							cellClass: getCellColor(i + 1),
							columnClass: 'px-1 py-1'
						})
					});
				} else {
					headers.push({
						text: c.name + ' (qq)',
						name: c.name,
						value: c.id,
						align: 'center',
						type: 'number-format',
						class: getCellColor(i < 2 ? i + 1 : 3),
						cellClass: getCellColor(i + 1),
						columnClass: 'px-1 py-1'
					});
				}
			})

			return headers;
		},

		// dialog
		dialogHeaders() {
			const headers = [
				{
					text: this.$T('headers.item'),
					name: 'itemName',
					value: 'itemId',
					setValueExpr: val => this.isPreview ? this.getItemById(val).name : '-',
					printValueExpr: val => val !== null ? this.getItemById(val)?.name ? this.getItemById(val).name : '-' : '-',
					columnClass: 'px-2',
					width: 140,
				},
				{
					text: this.$t('headers.quantity'),
					name: 'quantity',
					value: 'quantity',
					columnClass: 'px-2',
					type: 'number-format',
					inputRules: [() => this.dialogData.entires.filter(c => c.quantity).length > 0],
					width: 80,
					writable: !this.isPreview
				},
				{
					text: this.$t('headers.owner'),
					name: 'ownerId',
					value: 'ownerId',
					setValueExpr: val => this.isPreview ? this.owners.find(c => c.id === val)?.name ? this.owners.find(c => c.id === val)?.name : 'Ugarit' : '-',
					printValueExpr: val => this.owners.find(c => c.id === val)?.name ? this.owners.find(c => c.id === val)?.name : 'Ugarit',
					columnClass: 'px-2',
					width: 120,
				},
				// !this.isPreview 
				// 	? {
				// 		text: this.$t('headers.lot'),
				// 		name: 'lot',
				// 		value: 'lot',
				// 		columnClass: 'px-2',
				// 		writable: !this.isPreview
				// 	} 
				// 	: null,
				{
					text: this.$t('headers.notes'),
					name: 'notes',
					value: 'notes',
					width: 200,
					columnClass: 'px-2',
					writable: !this.isPreview,
					printValueExpr: val => val !== null ? val : '-',
				},
			]
			return headers.filter(c => c !== null)
		},
		headersOrder () {
			return [
				{
					text: this.$t('headers.weight') + ' (qq)',
					name: 'weight',
					value: 'id',
					align: 'center',
					printValueExpr: val => this.$options.filters.numberFormat(fixNumber(this.productionJournals.find(c => c.id === val)?.workItems.reduce((res, a) => res + a.quantity, 0)))
				},
				{
					text: this.$T('headers.item'),
					name: 'itemName',
					value: 'workItems',
					setValueExpr: val => val ? val.map(c => this.getItemById(c.itemId).name).join(', ') : '-',
					columnClass: 'px-2',
					width: 140,
				},
				{
					text: this.$t('headers.owner'),
					name: 'ownerId',
					value: 'workItems',
					setValueExpr: val => val.length ? val.map(c => c.ownerId !== null ? this.owners.find(m => m.id === c.ownerId)?.name : 'Ugarit').join(' ') : '-',
					columnClass: 'px-2',
					width: 120,
				},
				{
					text: this.$t('headers.lot'),
					name: 'lot',
					value: 'workItems',
					setValueExpr: val => val.map(c => c.lot).join(' '),
				},
				{
					text: this.$t('headers.notes'),
					name: 'notes',
					value: 'workItems',
					setValueExpr: val => val.map(c => c.notes).join(' '),
					printValueExpr: val => val.map(c => c.notes).join(' ') ? val.map(c => c.notes).join(' ') : '-',
					width: 200,
					columnClass: 'px-2',
				},
			]
		},
		headers() {
			const headers = [
				{
					text: 'S.N',
					name: 'journalNo',
					value: 'subJournalNo',
					width: 40
				},
				...[
					this.currentProductionType === productionType.order
						? this.headersOrder
						: this.itemsHeaders,
				].flat(),
				this.currentProductionType !== productionType.order 
					? {
						text: this.$T('total'),
						name: 'totalQuantity',
						value: 'totalQuantity',
						setValueExpr: val => val > 0 ? this.$options.filters.numberFormat(fixNumber(val)) : 0
					} 
					: null,
				{
					text: '',
					name: 'actions',
					value: 'actions',
					width: 0,
					noPrint: true,
				},
			];
			const headerActual = headers.filter(c => c !== null)
			for (let i = 0; i < headerActual.length; i++) {
				headerActual[i].columnClass = headerActual[i].columnClass ? headerActual[i].columnClass + ' px-2' : 'px-2'
			}

			return headers.filter(c => c !== null);
		},
		headersCardamom() {
			return [
				{ 
					text: 'Owner', 
					name: 'ownerId', 
					value: 'ownerId', 
					noNotAvailableText: true,
					setValueExpr: val => val ? this.owners.find(c => c.id === val)?.name : 'Ugarit',
				}, 
				{ 
					text: 'Quantity', 
					name: 'remainingQty', 
					value: 'remainingQty', 
					type: 'number-format',
					setValueExpr: val => val + ' qq',
					columnClass: 'font-weight-bold' 
				}
			]
		}
	},
	
	methods: {
		fixNumber,
		filter(newScrollOptions) {
			this.total = 0
			let page = 1;
			if (newScrollOptions) {
				page = newScrollOptions.page;
			} else if (this.$refs.table) {
				this.$refs.table.resetShownRows();
			}
			const itemsPerPage = this.scrollOptions.itemsPerPage;
			
			this.loading = true;
			return this.$store.dispatch('productionJournals/fetchAll', {
				fromDate: this.filterData.fromDate,
				toDate: this.filterData.toDate,
				type: this.currentProductionType,
				page: page,
				perPage: itemsPerPage || 20,
				ownerIds: this.filterData.ownerIds || [],
			}).then(({ data, total, headers }) => {
				const tableItems = [];
				data.forEach((entry) => {
					tableItems.push({
						...entry,
						...this.itemsHeaders.reduce((res, header) => {
							res[header.value] = entry.workItems.find(c => c.itemId === header.value)?.quantity ?? 0;
							return res;
						}, {})
					});
				});
				this.totalItems = total;
				this.total = headers['x-grand-total-quantity']
				this.$refs.table.addScrollItems(tableItems);
			}).finally(() => {
				this.loading = false;
			})
		},

		submit() {
			if (this.$refs.orderForm.validate()) {
				this.submitLoading = true;
				const actionName = !this.orderItem ? 'create' : 'update';
				this.$store.dispatch(`productionJournals/${actionName}`, {
					id: this.orderItem?.id,
					date: this.dialogData.date,
					workType: this.currentProductionType,
					workItemRequests: this.dialogData.entires.filter(c => c.quantity).map(c => ({
						quantity: c.quantity,
						ownerId: c.ownerId,
						lot: this.lot || 0,
						itemId: c.itemId,
						date: this.dialogData.date,
						notes: c.notes || '',
					}))
				}).then(() => {
					const type = this.currentProductionType === productionType.order ? 'production-order' : 'order-result';
					this.$eventBus.$emit(
						'show-snackbar',
						!this.orderItem
							? this.$T(`${type}-added`)
							: this.$T(`${type}-updated`),
						'info'
					);
					this.dialog = false;
					this.fetchCardamom()
					this.filter();
				}).finally(() => {
					this.submitLoading = false;
				});
			}
		},

		fetchCardamom() {
			this.$store.dispatch('transactions/fetchCardammon', { 
				cardammomStatus: cardamomStatus.inSorting, 
				Withdetails: true
			})
		},

		printAll() {
			this.productionJournals = []
			this.$store.dispatch('productionJournals/fetchAll', {
				fromDate: this.filterData.fromDate,
				toDate: this.filterData.toDate,
				type: this.currentProductionType,
				ownerIds: this.filterData.ownerIds || [],
				usePagination: false
			}).then((data) => {
				data.forEach((entry) => {
					this.productionJournals.push({
						...entry,
						...this.itemsHeaders.reduce((res, header) => {
							res[header.value] = entry.workItems.find(c => c.itemId === header.value)?.quantity ?? 0;
							return res;
						}, {})
					});
				});

				this.generatePrint(true)
			})
		},

		generatePrint(all = false) {
			const headers = all ? this.headers.filter(c => !c.noPrint) : this.dialogHeaders;
			const customTitleHtml = [
				{
					text: this.$T('inputs.lot'),
					value: this.lot || 0,
					width: '20%',
				}
			].filter(c => c.value)
				.map(({ text, value, width }) => `
					<div style="max-width: ${width || '15%'}; margin-right: 2%; white-space: nowrap;">
						${text}: <b>${value}</b>
					</div>
				`)
				.join('');
			
			const html = generateHtmlPdf({
				titleData: {
					Type: 'Production Report',
					Date: all ? this.filterData.fromDate !== null && this.filterData.toDate !== null ? (this.filterData.fromDate + ' - ' + this.filterData.toDate) : '' : this.dialogData.date,
					Owners: all 
						? this.filterData.ownerIds.map(f => [
							...this.owners, 
							{ 
								id: '00000000-0000-0000-0000-000000000000', 
								name: 'Ugarit', 
								type: 1 
							}
						].find(c => c.id === f)?.name).join(', ') 
						: '',
				},

				customTitleHtml: `<div style="display: flex; flex-wrap: wrap; margin-top: 10px;">${customTitleHtml}</div>`,
				headers: headers.map(c => c.text),
				data: (all ? this.productionJournals : this.dialogData.entires).map(item =>
					headers.map(header => 
						header.printValueExpr
							? header.printValueExpr(item[header.value])
							: header.setValueExpr
								? header.setValueExpr(item[header.value])
								: item[header.value]
					)
				),
				total: this.$options.filters.numberFormat(fixNumber(+this.total)) + ' qq'
			});
			
			printJS({
				printable: html,
				type: 'raw-html',
			})
		},
	},

	created() {
		this.filter()
		this.fetchCardamom()
		if (this.$route.query.id) {
			this.$store.dispatch('materialJournals/fetchById', { id: this.$route.query.id })
				.then(data => {
					this.lot = data.entries.length ? data.entries[0].lot : 0
					this.orderItem = {
						id: data.id,
						date: data.date,
						workItems: data.entries.map(c => ({
							itemId: c.itemId,
							quantity: c.in !== null ? c.in : c.out,
							ownerId: c.ownerId,
							lot: c.lot,
							notes: c.notes,
						}))
					};
					this.isPreview = true;
					this.dialog = true;
				})
		}
	}
}
</script>

<style>

</style>